import { IconWrapper, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-gray-500)';

export const DeprecatedIcon = ({
  textColor = DEFAULT_COLOR,
  size,
}: IconProps) => (
  <IconWrapper size={size}>
    <path
      d="M16 25.5C21.2467 25.5 25.5 21.2467 25.5 16C25.5 10.7533 21.2467 6.5 16 6.5C10.7533 6.5 6.5 10.7533 6.5 16C6.5 21.2467 10.7533 25.5 16 25.5ZM14.6155 11H17.3847V17H14.6155V11ZM17.3847 19.8846C17.3847 20.6493 16.7648 21.2692 16.0001 21.2692C15.2354 21.2692 14.6155 20.6493 14.6155 19.8846C14.6155 19.1199 15.2354 18.5 16.0001 18.5C16.7648 18.5 17.3847 19.1199 17.3847 19.8846Z"
      fill={textColor}
    />
  </IconWrapper>
);
